import { ArticleParagraph3, Tooltip } from '@cian/ui-kit';

import { FC } from 'react';

import { TooltipContent } from './internal/components';
import { ICoworkingProfitBannerProps } from './types';

import * as styles from './CoworkingProfitBanner.css';

export const CoworkingProfitBanner: FC<ICoworkingProfitBannerProps> = props => {
  const { containerClassName } = props;

  return (
    <div className={containerClassName}>
      <Tooltip placement="top" theme="white" title={<TooltipContent />}>
        <button className={styles['button']}>
          <ArticleParagraph3 color="white_100">Почему это выгодно?</ArticleParagraph3>
        </button>
      </Tooltip>
    </div>
  );
};

CoworkingProfitBanner.displayName = 'CoworkingProfitBanner';
